// tslint:disable:max-line-length

import React from 'react';

export const ChartDoubleBar = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect y="8" width="16" height="1" />
      <rect x="0.5" y="3" width="3" height="4" />
      <rect x="12.5" y="2" width="3" height="5" />
      <rect x="3.5" y="10" width="3" height="6" />
      <rect x="9.5" y="10" width="3" height="4" />
      <rect x="6.5" width="3" height="7" />
    </svg>
  );
};
